import { render, staticRenderFns } from "./transfer-per-product.vue?vue&type=template&id=b58d4f6a&scoped=true"
import script from "./transfer-per-product.vue?vue&type=script&lang=js"
export * from "./transfer-per-product.vue?vue&type=script&lang=js"
import style0 from "./transfer-per-product.vue?vue&type=style&index=0&id=b58d4f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58d4f6a",
  null
  
)

export default component.exports